import NewTabLinkRenderer from 'components/AgGrid/NewTabLinkRenderer'

export const columnDefs = [
  {
    headerName: 'Bank Code',
    field: 'bank_code',
    suppressMenu: true,
    floatingFilter: false,
    cellRenderer: 'newTabLinkRenderer',
    cellRendererParams: {
      to: '/Metadata/Bank',
      linkIdentification: 'bank_id',
      contentField: 'bank_code',
    },
  },
  {
    headerName: 'Bank Name',
    field: 'bank_description',
    suppressMenu: true,
    floatingFilter: false,
  },
]

/**
 * This is for react component, the component content will not be wrapped in a cell
 * @type {{newTabLinkRenderer}}
 */
export const frameworkComponents = {
  newTabLinkRenderer: NewTabLinkRenderer,
}

/**
 * If you need your component to be wrapped in a cell, you need to use component
 */
export const components = {}
